import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "summary", "selectAll", "pageCount"]
  static values = { lineItemId: Number }
  
  connect() {
    this.updateSummary()
  }
  
  selectAll(event) {
    const selectAll = event.target.checked
    
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox !== event.target) {
        checkbox.checked = selectAll
      }
    })
    
    this.updateSummary()
  }
  
  updateSummary() {
    const selectedCheckboxes = this.checkboxTargets.filter(cb => cb.checked)
    const selectedCount = selectedCheckboxes.length
    const totalPages = selectedCheckboxes.reduce((sum, cb) => {
      return sum + parseInt(cb.dataset.pageCount || 0)
    }, 0)
    
    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = `${selectedCount} document${selectedCount !== 1 ? 's' : ''} selected`
    }
    
    if (this.hasPageCountTarget) {
      if (totalPages > 0) {
        this.pageCountTarget.textContent = `${totalPages} total page${totalPages !== 1 ? 's' : ''}`
      } else {
        this.pageCountTarget.textContent = ''
      }
    }
    
    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      const allChecked = this.checkboxTargets.length > 0 && 
                        this.checkboxTargets.every(cb => cb.checked)
      const someChecked = this.checkboxTargets.some(cb => cb.checked)
      
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = !allChecked && someChecked
    }
  }
}